import { useState } from "react";
import { STAGES } from "@/lib/constants";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { X, Plus } from "lucide-react";

export default function StageSelector({ selected, setSelected, custom, setCustom }) {
  const [draft, setDraft] = useState("");

  const toggle = (s) =>
    setSelected(selected.includes(s) ? selected.filter((x) => x !== s) : [...selected, s]);

  const addCustom = () => {
    const v = draft.trim();
    if (v && !custom.includes(v) && !STAGES.includes(v)) {
      setCustom([...custom, v]);
      setDraft("");
    }
  };

  return (
    <div data-testid="stage-selector">
      <Label>Works / Stages for this job</Label>
      <div className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 max-h-48 overflow-y-auto scrollbar-thin pr-1">
        {STAGES.map((s) => (
          <label key={s} className="flex items-center gap-2 text-sm cursor-pointer" data-testid={`stage-check-${s}`}>
            <Checkbox checked={selected.includes(s)} onCheckedChange={() => toggle(s)} />
            <span className="truncate">{s}</span>
          </label>
        ))}
      </div>
      {custom.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {custom.map((c) => (
            <span key={c} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full border border-primary/40 bg-primary/10 text-xs" data-testid={`custom-stage-chip-${c}`}>
              {c}
              <button type="button" onClick={() => setCustom(custom.filter((x) => x !== c))}><X className="h-3 w-3" /></button>
            </span>
          ))}
        </div>
      )}
      <div className="flex gap-2 mt-3">
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addCustom(); } }}
          placeholder="Add a custom stage…"
          data-testid="custom-stage-input"
        />
        <Button type="button" variant="outline" onClick={addCustom} data-testid="add-custom-stage-button">
          <Plus className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
